import React, { useState } from 'react';
import axios from '../config/axios';

const SignupPage = ({ onBack, onLoginLink }) => {
    const getInitialReferralCode = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('ref') || '';
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        currencyMultiplier: '1.00',
        referralCode: getInitialReferralCode()
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setError('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        // Validate currency multiplier
        const multiplier = parseFloat(formData.currencyMultiplier);
        if (isNaN(multiplier) || multiplier < 0.01 || multiplier > 10.00) {
            setError('DadBucks exchange rate must be between $0.01 and $10.00');
            return;
        }

        setLoading(true);
        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                username: formData.username,
                password: formData.password,
                currency_multiplier: parseFloat(formData.currencyMultiplier)
            };
            if (formData.referralCode) {
                payload.referral_code = formData.referralCode;
            }
            await axios.post('/api/v1/auth/register-parent', payload);
            onLoginLink(); // Redirect to login after successful signup
        } catch (err) {
            console.error('Signup error:', err);
            let message = 'Failed to create account. Please try again.';
            if (err.response && err.response.data) {
                if (typeof err.response.data === 'string') {
                    message = err.response.data;
                } else {
                    message = err.response.data.error || err.response.data.message || message;
                }
            }
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <button className="btn-back" onClick={onBack}>← Back to Home</button>
                <h2>Create Your Family Account</h2>
                <p className="subtitle">Start your journey to financial mastery</p>

                <form onSubmit={handleSignup}>
                    <div className="input-group">
                        <label htmlFor="signup-name">Full Name</label>
                        <input
                            id="signup-name"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="John Doe"
                            autoComplete="name"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-email">Email Address</label>
                        <input
                            id="signup-email"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="john@example.com"
                            autoComplete="email"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-username">Username</label>
                        <input
                            id="signup-username"
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            placeholder="johndoe123"
                            autoComplete="username"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-password">Password</label>
                        <input
                            id="signup-password"
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="••••••••"
                            autoComplete="new-password"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-confirm">Confirm Password</label>
                        <input
                            id="signup-confirm"
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="••••••••"
                            autoComplete="new-password"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-rate">DadBucks Exchange Rate</label>
                        <input
                            id="signup-rate"
                            type="number"
                            name="currencyMultiplier"
                            value={formData.currencyMultiplier}
                            onChange={handleChange}
                            placeholder="1.00"
                            step="0.01"
                            min="0.01"
                            max="10.00"
                            aria-describedby="rate-help"
                            required
                        />
                        <small id="rate-help" style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
                            How much is 1 DadBuck worth in real money? (Min: $0.01, Max: $10.00)
                        </small>
                    </div>
                    <div className="input-group">
                        <label htmlFor="signup-referral">Referral Code (Optional)</label>
                        <input
                            id="signup-referral"
                            type="text"
                            name="referralCode"
                            value={formData.referralCode}
                            onChange={handleChange}
                            placeholder="e.g. awesomeparent"
                            aria-describedby="referral-help"
                        />
                        <small id="referral-help" style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
                            Get a free month of Premium if you were referred!
                        </small>
                    </div>

                    {error && <p className="error-message" role="alert" aria-live="assertive">{error}</p>}

                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? 'Creating Account...' : 'Sign Up'}
                    </button>
                </form>

                <div className="login-footer">
                    Already have an account? <span onClick={onLoginLink}>Sign in here</span>
                </div>
            </div>
        </div>
    );
};

export default SignupPage;
